<template>
  <div class="billing-information">
    <div class="section-title">开票信息</div>
    <el-form label-width="150px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label-width="150px">
            <span slot="label"> 是否开票： </span>
            <span>{{
              formData.isInvoiced === "Y"
                ? "是"
                : formData.isInvoiced === "N"
                ? "否"
                : "-"
            }}</span>
          </el-form-item>
        </el-col>
        <el-col
          :span="8"
          v-if="formData.isInvoiced === 'Y' && formData.invoiceDate"
        >
          <el-form-item label-width="150px">
            <span slot="label"> 开票时间： </span>
            <span>{{ formData.invoiceDate | getDate }}</span>
          </el-form-item>
        </el-col>
        <el-col
          :span="8"
          v-if="formData.isInvoiced === 'Y' && formData.taxRate"
        >
          <el-form-item label-width="150px">
            <span slot="label"> 发票税率(%)： </span>
            <span>{{ formData.taxRate }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <div
        v-if="formData.isInvoiced === 'Y'"
        v-for="(item, index) in formData.invoiceAttaches || []"
        :key="index"
      >
        <div class="form-title-item">票据信息 {{ index + 1 }}</div>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label-width="150px">
              <span slot="label"> 任务大类： </span>
              <span>{{ item.name || "-" }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="150px">
              <span slot="label"> 开票金额(元)： </span>
              <span style="color: #ff5f1f">{{ item.amount | numDigit }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="150px" class="w100f">
              <span slot="label"> 发票类目： </span>
              <el-tooltip
                :content="getInvoiceCategoryName(item.invoiceCategory)"
                placement="top-start"
              >
                <div class="nowrap-ellipsis">
                  {{ getInvoiceCategoryName(item.invoiceCategory) }}
                </div>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="150px">
              <span slot="label"> 结算单附件： </span>
              <div class="file-list">
                <div
                  v-for="(file, idx) in getSettleAttach(item)"
                  :key="idx"
                  class="file-item"
                >
                  <span class="file-name">{{
                    file.fileName || file.name
                  }}</span>
                  <span class="file-preview" @click="onPreview(file)"
                    >查看</span
                  >
                  <span
                    class="file-preview"
                    @click="download(file.path, file.fileName, file.fileName)"
                    >下载</span
                  >
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="150px">
              <span slot="label"> 票据附件： </span>
              <div class="file-list">
                <div class="file-item">
                  <span class="file-name">{{
                    item.fileName || item.name
                  }}</span>
                  <span class="file-preview" @click="onPreview(item)"
                    >查看</span
                  >
                  <span
                    class="file-preview"
                    @click="
                      download(item.path, item.fileName, item.fileName)
                    "
                    >下载</span
                  >
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <el-row :gutter="24" v-else-if="formData.isInvoiced === 'N'">
        <el-col :span="24">
          <el-form-item label-width="150px">
            <span slot="label"> 结算单附件： </span>
            <div class="file-list">
              <div
                v-for="(file, idx) in formData.settleAttaches || []"
                :key="idx"
                class="file-item"
              >
                <span class="file-name">{{ file.fileName || file.name }}</span>
                <span class="file-preview" @click="onPreview(file)">查看</span>
                <span
                  class="file-preview"
                  @click="download(file.path, file.fileName, file.fileName)"
                  >下载</span
                >
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { download } from "@/uilt/download";

export default {
  name: "BillingInformation",
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      download,
    };
  },
  methods: {
    onPreview(file) {
      let fileSuffix = "";
      if (file.name) {
        fileSuffix = file.name
          ? file.name.substring(file.name.lastIndexOf(".") + 1)
          : "";
      }
      if (file.fileName) {
        fileSuffix = file.fileName
          ? file.fileName.substring(file.fileName.lastIndexOf(".") + 1)
          : "";
      }
      if (fileSuffix == "ofd") {
        return window.open(
          "https://ofd.xdocin.com/view?src=" + encodeURIComponent(file.path)
        );
      }

      if (["png", "jpeg", "jpg", "pdf", "zip", "rar"].includes(fileSuffix)) {
        return window.open(file.path);
      }
      window.open(
        "https://view.officeapps.live.com/op/view.aspx?src=" + file.path
      );
    },
    getSettleAttach(item) {
      if (!this.formData.settleAttaches || !item.batchGuid || !item.name) {
        return [];
      }
      return this.formData.settleAttaches.filter((file) => {
        return file.batchGuid === item.batchGuid && file.name === item.name;
      });
    },
    getInvoiceCategoryName(categoryValue) {
      const list = this.getCodeListByKey("发票类目");
      const item = list?.find((item) => item.value == categoryValue);
      return item?.text || "-";
    },
  },
};
</script>

<style lang="less" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.billing-information {
  padding: 0 20px 20px;
}
.section-title {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 600;
  margin-left: 24px;
}

.form-title-item {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  margin-left: 40px;
}
.file-list {
  // margin-top: 5px;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  color: #4fa1a4;
  word-break: keep-all;
}
.billing-info-box {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.billing-info-item {
  display: flex;
  align-items: center;
}
.billing-label {
  color: #606266;
  font-weight: 500;
}
.billing-value {
  color: #303133;
  margin-left: 8px;
}
.file-item {
  display: flex;
  align-items: center;
}
.file-name {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.no-invoice-files {
  margin-top: 10px;
}
</style>
